const PRIORITY = {
  P0: 'P0',
  P1: 'P1',
  P2: 'P2',
};

const TEAM = {
  PAAR: 'PAAR',
};

export { PRIORITY, TEAM };
